import { Component, ComponentChild } from 'preact'
import InputGroup from '../../control-components/ui-components/InputGroup'
import { GroupsWidgetConfig } from './index.sync'
import ConfigurationSectionLabel from '@insided/destination/modules/Customization/configurator/ConfigurationSectionLabel'

interface NewData {
  buttonLabel?: string
  buttonURL?: string
}

interface ButtonsProps {
  config: GroupsWidgetConfig
  onChange: (newData: NewData) => void
}

interface State extends NewData {
  inputInFocus: boolean
}

export class Buttons extends Component<ButtonsProps, State> {
  constructor (props: ButtonsProps) {
    super(props)

    this.state = {
      inputInFocus: false,
      buttonLabel: props.config.buttonLabel || '',
      buttonURL: props.config.buttonURL || ''
    }

    this.onChangeButtonLabel = this.onChangeButtonLabel.bind(this)
    this.onChangeButtonURL = this.onChangeButtonURL.bind(this)
    this.onChangeSend = this.onChangeSend.bind(this)
  }

  onChangeButtonLabel (newButtonLabel: string) {
    this.setState({
      buttonLabel: newButtonLabel
    }, this.onChangeSend)
  }

  onChangeButtonURL (newButtonURL: string) {
    this.setState({
      buttonURL: newButtonURL
    }, this.onChangeSend)
  }

  onChangeSend () {
    const newData: NewData = {
      buttonLabel: this.state.buttonLabel,
      buttonURL: this.state.buttonURL
    }

    this.props.onChange(newData)
  }

  render () {
    const { config } = this.props
    const {
      buttonLabel,
      buttonURL
    } = config
    return (
      <ConfigurationSectionLabel title='Buttons'>
        <div className='groups-widget__buttons'>
          <InputGroup
            title='Button label (optional)'
            type='text'
            placeholder='Show more'
            onChange={(e: { target: HTMLInputElement }) => {
              this.onChangeButtonLabel(e.target.value)
            }}
            value={buttonLabel}
          />
          <InputGroup
            title='URL (optional)'
            type='url'
            placeholder='https://example.com'
            onChange={(e: { target: HTMLInputElement }) => {
              this.onChangeButtonURL(e.target.value)
            }}
            value={buttonURL}
          />
        </div>
      </ConfigurationSectionLabel>
    )
  }
}

export default Buttons
